module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default payment-info-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Payment Information")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.hasPaymentInfo) ? _c('div', [_c('div', {
    staticClass: "pull-right"
  }, [_c('stripe-upgrade', {
    attrs: {
      "form-data": _vm.stripeForm,
      "action": _vm.routes.form_post_update,
      "text": "Update Details"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "payment-info-spacer"
  }, [_c('p', [_c('strong', [_vm._v("Card:")]), _vm._v(" " + _vm._s(_vm.paymentInfo.card_brand) + " ending in "), _c('strong', [_vm._v(_vm._s(_vm.paymentInfo.card_last_four))])]), _vm._v(" "), (_vm.billingAddress) ? _c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('strong', [_vm._v("Address:")]), _vm._v(" " + _vm._s(_vm.billingAddress))]) : _vm._e()])]) : _c('em', [_vm._v("No payment information added yet")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68394d43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/PaymentInfo.vue
// module id = 17
// module chunks = 0